export const TOP_SAFE = 62
export const TRIGGER_HEIGHT_L1 = 44
export const TRIGGER_HEIGHT_L2 = 32
export const SUBGROUP_ITEM_HEIGHT = 32
export const SUBGROUP_VERTICAL_PADDING = 20
export const CASCADE_MENU_TOTAL_WIDTH = 800
export const CASCADE_MENU_GAP = 3
export const CASCADE_MOUSE_LEAVE_DELAY = 0.2
export const CASCADE_L2_WIDTH = 180
export const CASCADE_L3_WIDTH = CASCADE_MENU_TOTAL_WIDTH - CASCADE_MENU_GAP * 2 - CASCADE_L2_WIDTH

export function getPopupContainer () {
  return document.querySelector('#sidebar-wrap')
}

export function getBounds (openCloudShell, cloudShellHeight) {
  const container = getPopupContainer()
  if (!container) {
    const cloudShellOffset = openCloudShell ? cloudShellHeight : 0
    const bottomSafe = window.innerHeight - cloudShellOffset
    return {
      topSafe: TOP_SAFE,
      bottomSafe,
      maxHeight: Math.max(bottomSafe - TOP_SAFE, 100),
    }
  }
  const rect = container.getBoundingClientRect()
  const topSafe = rect.top + TOP_SAFE
  const bottomSafe = rect.bottom
  return {
    topSafe,
    bottomSafe,
    maxHeight: Math.max(bottomSafe - topSafe, 100),
  }
}

export function calcPanelTop ({
  triggerEl,
  panelHeight,
  triggerHeight,
  openCloudShell,
  cloudShellHeight,
}) {
  if (!triggerEl) return TOP_SAFE
  const { topSafe, bottomSafe, maxHeight } = getBounds(openCloudShell, cloudShellHeight)
  const effectiveHeight = Math.min(panelHeight, maxHeight)
  const triggerRect = triggerEl.getBoundingClientRect()
  const defaultTop = triggerRect.top + triggerHeight / 2 - effectiveHeight / 2
  let targetTop = defaultTop
  if (targetTop < topSafe) {
    targetTop = topSafe
  }
  if (targetTop + effectiveHeight > bottomSafe) {
    targetTop = bottomSafe - effectiveHeight
  }
  if (targetTop < topSafe) {
    targetTop = topSafe
  }
  return Math.round(targetTop)
}

export function calcPanelLeftFromRect (rect) {
  return Math.round(rect.right + CASCADE_MENU_GAP)
}

export function applyPanelMaxHeight (panelEl, openCloudShell, cloudShellHeight, contentSelector) {
  if (!panelEl) return
  const { maxHeight } = getBounds(openCloudShell, cloudShellHeight)
  const maxHeightPx = `${maxHeight}px`
  panelEl.style.setProperty('--cascade-max-height', maxHeightPx)
  const body = contentSelector ? panelEl.querySelector(contentSelector) : null
  if (body) {
    body.style.setProperty('max-height', maxHeightPx, 'important')
  }
}

export function clampPanelTop (panelEl, top, openCloudShell, cloudShellHeight) {
  if (!panelEl) return top
  const { topSafe, bottomSafe } = getBounds(openCloudShell, cloudShellHeight)
  const height = panelEl.offsetHeight
  let targetTop = top
  if (targetTop < topSafe) {
    targetTop = topSafe
  } else if (targetTop + height > bottomSafe) {
    targetTop = bottomSafe - height
  }
  if (targetTop < topSafe) {
    targetTop = topSafe
  }
  return Math.round(targetTop)
}
